const BASEURL = 'https://mhy-quiz-server.onrender.com/words';

const getWords = () => fetch(BASEURL).then(res => res.json()).then(res => res);

export default getWords;